import React from 'react';

export const useQuery = <T = string>(paramName: string | null): T | null => {
  const { search, hash } = document.location;
  // hash handling when query has path for analytics module: /analytics/#/subpath
  const hasHashValue = hash.length > 0;

  return React.useMemo(() => {
    const value = `${new URLSearchParams(search).get(paramName || '')}${hasHashValue ? hash : ''}` as T;

    if (value === 'null') {
      return null;
    }

    return value;
  }, [search, hash]);
};
